<div class="hero-section">
  <div class="hero-shell">
    <div class="hero-content">
      <span class="hero-eyebrow">orderYaa Accounting</span>

      <h1 class="hero-title">
        Every Number. Always <span class="hero-title-highlight">Balanced</span>.
      </h1>

      <p class="hero-description">
        Ledgers, journal entries, chart of accounts, tax, and financial reports —
        every entry double-checked, every book balanced, automatically.
      </p>

      <div class="hero-buttons">
        <button class="hero-btn hero-btn-primary" type="button" (click)="showRegister = true">Start free trial</button>
        <a class="hero-btn hero-btn-secondary" href="https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-07" target="_blank" rel="noopener noreferrer">Book a meeting</a>
      </div>
    </div>

    <div class="activity-feed" aria-hidden="true">
      <div class="activity-feed-head">
        <span>Recent Journal Entries</span>
        <span class="activity-feed-live"><span class="activity-feed-dot"></span> Live</span>
      </div>

      <ul class="activity-feed-list">
        <li *ngFor="let entry of ticker.slice(0, 5)">
          <span class="activity-feed-id">{{ entry.id }}</span>
          <span class="activity-feed-type">{{ entry.type }}</span>
          <span class="activity-feed-amount">{{ entry.amount }}</span>
          <span class="activity-feed-status" [class.activity-feed-status--draft]="entry.status === 'Draft'">{{ entry.status }}</span>
        </li>
      </ul>
    </div>
  </div>
</div>

<app-register
  *ngIf="showRegister"
  [selectedApps]="accountingApp"
  (goBack)="showRegister = false"
></app-register>
